import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost/')({
  beforeLoad: () => {
    throw redirect({
      to: '/software/contract-and-cost/deal/contract'
    });
  }
});